import {
  REQUEST_SPOILAGE_REASONS,
  REQUEST_PRODUCTSV2,
  REQUEST_PRODUCT_CATEGORIES,
  ProductsState
} from "./types";

const initialProductsState: ProductsState = {
  productState: { isLoading: true, products: [] },
  categories: [],
  spoilageReasons: []
};

export function storeClusterProductReducer(
  state = initialProductsState,
  action: any
) {
  switch (action.type) {
    case REQUEST_PRODUCTSV2:
      return {
        ...state,
        productState: { isLoading: false, products: action.payload }
      };
    case REQUEST_SPOILAGE_REASONS:
      return { ...state, spoilageReasons: action.payload };
    case REQUEST_PRODUCT_CATEGORIES:
      return { ...state, categories: action.payload };
    default:
      return state;
  }
}
